var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentNode && _vm.currentNode.id !== '-1' && _vm.position)?_c('div',{staticClass:"edit-wrap",style:(_vm.position)},[(_vm.currentNode.outDocFlow)?_c('resizer',{on:{"context":_vm.handleContext}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }